import React from "react";
import { NewButton } from "@/components/basic";
import Image from "next/image";
import { logError } from "@gettactic/helpers";
import useTeamsApp from '@/hooks/useTeamsApp';

export const EmbeddedLoginScreen: React.FC = () => {
  const teamsClient = useTeamsApp();
  
  React.useEffect(() => {
    if (teamsClient) {
      teamsClient.app.notifySuccess();
    }
  }, [teamsClient]);
  
  const handleLogin = async (client: any) => {
    if (client == null) {
      return;
    }

    client.authentication
      .authenticate({
        url: `${process.env.NEXT_PUBLIC_TACTIC_API_URL}/auth/login?returnUrl=${encodeURIComponent(
          `${process.env.NEXT_PUBLIC_TACTIC_DOMAIN_AND_PORT}/microsoft-teams/tab-auth-done`
        )}`,
        width: 600,
        height: 535
      })
      .then((result: any) => {
        logError("Login succeeded: " + result);
        window.location.assign(
          `${(process.env.NEXT_PUBLIC_TACTIC_DOMAIN_AND_PORT || "").replace("https://", "https://app.")}`
        );
      })
      .catch((err: any) => {
        logError("Login failed: " + err);
      });
  };

  return (
    <>
      <div className="flex h-screen items-start justify-center">
        <div className="flex flex-col md:flex-row mt-2 md:mt-16 rounded-[40px] md:shadow-xl p-8 md:p-16">
          <div className="flex flex-col justify-between">
            <div className="flex flex-col self-center h-32">
              <Image
                src="https://cdn.gettactic.com/tactic_primary_logo.svg"
                width={300}
                height={60}
                alt="Tactic"
                priority={true}
              />
              <p className="self-center font-bold text-orange-400 text-xl mt-4">
                Office Management
              </p>
            </div>
            <div className="self-center h-32 mt-8">
              <p className="text-xl text-center font-bold text-secondary-bg">
                Welcome to Tactic!
              </p>
              <p className="text-xl text-center font-bold text-secondary-bg">
                Log in to access your interactive office map!
              </p>
            </div>
            <div className="flex flex-col self-center">
              <NewButton.Component
                variant={NewButton.Variant.Primary}
                size="md"
                onClick={() => handleLogin(teamsClient)}
              >
                Login
              </NewButton.Component>
              <p className="self-center mt-4 text-gray-400 font-bold text-sm">
                Don't have an account? Click{" "}
                <a
                  href="https://gettactic.com/signup"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 underline text-sm"
                >
                  here
                </a>
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center md:justify-between md:ml-32">
            <img
              className="m-2 mt-8 md:mt-0 md:mb-8"
              src="https://cdn.gettactic.com/website/images/desk.webp"
              alt="desk"
            />
            <div className="h-0.5 bg-gray-200" />
            <img
              className="hidden md:flex m-2 mt-8"
              src="https://cdn.gettactic.com/website/images/meeting_room.webp"
              alt="meeting room"
            />
          </div>
        </div>
      </div>
    </>
  );
};
